import imagesLib from './images.json'
import moment from 'moment'
import lodash from 'lodash'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import FileSaver from 'file-saver'
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  data() {
    return {
      loading: false,
      chartBarVisible: false,
      chartBase64: '',
      dataCollectionReport: null,
      chartOptionsReport: {
        bezierCurve: false,
        animation: {
          onComplete: this.chartOnLoadComplete
        },
        title: {
          display: true,
          text: '',
          fontSize: 17
        },
        legend: {
          labels: {
            fontColor: 'black',
            usePointStyle: true
          },
          position: 'bottom'
        },
        scales: {
          yAxes: [
            {
              gridLines: { color: '#607d8b' },
              ticks: {
                fontColor: 'black',
                // suggestedMin: 15
                suggestedMin: 0
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }
          ],
          xAxes: [
            {
              gridLines: { color: '' },
              ticks: {
                fontColor: 'black'
              }
            }
          ]
        }
      },
      form: {
        startDate: '',
        endDate: '',
        reportType: '',
        dataForm: 'daily_avg',
        sensorType: '',
        location: ''
      },
      dateOptions: [
        {
          value: 'daily_avg',
          label: 'Daily'
        },
        {
          value: 'monthly_avg',
          label: 'Monthly'
        },
        {
          value: 'yearly_avg',
          label: 'Yearly'
        }
      ],
      sensorTypeOptions: [],
      datePickerOptions: '',
      periodDatePickerType: 'date',
      checkboxes: [],
      dropdownReport: [],
      checkedNodes: [],
      tableColumns: [],
      tableRows: []
    }
  },
  computed: {
    lastPath: function () {
      const arrayPath = this.$route.path.split('/')
      return arrayPath[arrayPath.length - 1]
    },
    columnDateOutputFormat() {
      if (this.form.dataForm === 'yearly_avg') return 'yyyy'
      else if (this.form.dataForm === 'monthly_avg') return 'MMM yyyy'
      else return 'dd MMM yyyy'
    },
    momentDateOutputFormat() {
      if (this.form.dataForm === 'yearly_avg') return 'YYYY'
      else if (this.form.dataForm === 'monthly_avg') return 'MMM YYYY'
      else return 'DD MMM YYYY'
    }
  },
  mounted() {
    this.fetchDropdownReport()
  },
  methods: {
    createChart(data = {}) {
      this.chartBarVisible = true

      // Set chart title
      this.chartOptionsReport.title.text = `Average ${
        this.lastPath === 'ups'
          ? this.getAllUppercase(this.lastPath)
          : this.getFirstCharUppercase(this.lastPath)
      } By Sub Device`

      const labels = data.ListLabel
      const datalist = data.AverageHistorical.map((item) => item.DecimalVal)
      // set label string
      const labelString = () => {
        if (this.lastPath === 'temperature') return '°C'
        else if (this.lastPath === 'humidity') return '%'
        else {
          if (this.form.sensorType === 'OUTPUT_ACTIVE_POWER') return 'kW'
          else if (this.form.sensorType === 'BATTERY_TIME_REMAINING')
            return 'min'
          return 'V'
        }
      }
      this.chartOptionsReport.scales.yAxes[0].scaleLabel.labelString = labelString()

      this.dataCollectionReport = {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: `AVERAGE VALUE OF ${
              this.sensorTypeOptions.find(
                (sensorType) => sensorType.value === this.form.sensorType
              )?.label
            }`,
            backgroundColor: '#6199CC',
            borderColor: '#6199CC',
            strokeColor: '#79D1CF',
            data: datalist,
            fill: false,
            pointRadius: 3
          }
        ]
      }
    },
    validateForm() {
      let isValid = true

      if (this.form.startDate === '' || this.form.endDate === '') {
        isValid = false
        this.$message.error('Please choose date correctly')
      } else if (this.form.sensorType === '') {
        isValid = false
        this.$message.error('Please choose sensor type first')
      } else if (this.checkedNodes.length < 1) {
        isValid = false
        this.$message.error('Please check any sub device first')
      }

      return isValid
    },
    async submit() {
      this.showLoading()

      try {
        // Validating form before fetching data
        if (!this.validateForm()) {
          this.hideLoading()
          return
        }

        // Create payload for fetching data report purpose
        const data = {
          dataForm: this.form.dataForm,
          typeSensor: this.form.sensorType,
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          SubDeviceName: [...this.checkedNodes.map((item) => item.label)]
        }

        // Fetching data report
        const res = await this.$axios.post(
          'Report/PostCreateAverageReportBySubDeviceName',
          data
        )

        // Create chart with res.data
        this.createChart(res.data)

        const subDeviceNames = res.data.SubDeviceName

        // Set table columns
        this.setTableColumns(subDeviceNames)

        const rowGroupedByTimestamp = this.getGroupRowByTimestamp(
          subDeviceNames,
          res.data.ListOfSensor
        )
        // Set table rows
        this.setTableRows(subDeviceNames, rowGroupedByTimestamp)

        this.hideLoading()
      } catch (err) {
        console.log(err)
        this.hideLoading()
      }

      this.hideLoading()
    },
    setTableRows(subDeviceNames, rowGroupedByTimestamp) {
      let tableRows = []

      for (const objectIndex in rowGroupedByTimestamp) {
        // !note: objectIndex is date string
        let value = { datetime: objectIndex }
        rowGroupedByTimestamp[objectIndex].forEach((item, index) => {
          if (subDeviceNames.includes(subDeviceNames[index])) {
            value[subDeviceNames[index]] = `${item.value}${item.unit}`
          }
        })
        tableRows.push(value)
      }

      this.tableRows = tableRows
    },
    setTableColumns(subDeviceNames) {
      this.tableColumns = subDeviceNames.map((item) => {
        return {
          label: item,
          field: item,
          type: 'number'
        }
      })
      // Add datetime column to tableColumns
      this.tableColumns.unshift({
        label: 'Date',
        field: 'datetime',
        type: 'date',
        dateInputFormat: 'yyyy-MM-dd',
        dateOutputFormat: this.columnDateOutputFormat
      })
    },
    getGroupRowByTimestamp(subDeviceNames, listOfSensorData) {
      const listOfSensors = listOfSensorData.filter((item) =>
        subDeviceNames.includes(item.SubDeviceName)
      )
      let historicalValues = []

      listOfSensors.forEach((item) => {
        item.HistoricalValue.forEach((value) => {
          historicalValues.push({
            deviceName: item.SubDeviceName,
            value: value.DecimalVal,
            timestamp: moment(value.Timestamp).format('YYYY-MM-DD'),
            unit: value.Unit
          })
        })
      })

      // Should group historicalvalues by timestamp for table purposes
      return lodash.groupBy(historicalValues, function (history) {
        return history.timestamp
      })
    },
    async fetchDropdownReport() {
      this.showLoading()

      try {
        const res = await this.$axios.get(
          `Sensor/DropdownReportByTreeSensorCollection?filter=${this.lastPath}`
        )

        this.dropdownReport = res.data

        res.data.forEach((item) => {
          this.sensorTypeOptions.push({
            value: item.value,
            label: item.label
          })
        })

        this.hideLoading()
      } catch (err) {
        console.log(err)
        this.hideLoading()
      }
      this.hideLoading()
    },
    onChangePicker() {
      if (this.form.dataForm == 'monthly_avg')
        this.periodDatePickerType = 'month'
      else if (this.form.dataForm == 'yearly_avg')
        this.periodDatePickerType = 'year'
      else this.periodDatePickerType = 'date'

      this.form.startDate = ''
      this.form.endDate = ''
    },
    onChangeTypeSensor() {
      // Reset checkedNodes
      this.checkedNodes = []

      // Find one dropdownReport data which its value equals to form.sensorType
      const selectedDropdownReport = this.dropdownReport.find(
        (item) => item.value === this.form.sensorType
      )
      let index = 1,
        checkboxes = []

      selectedDropdownReport.listSubDevice.forEach((item) => {
        checkboxes.push({
          id: index,
          label: item.subdevice
        })
        index++
      })

      this.checkboxes = checkboxes
    },
    validateDate() {
      if (this.form.startDate != '' && this.form.endDate != '') {
        let temp1 = new Date(this.form.startDate)
        let temp2 = new Date(this.form.endDate)
        if (temp1 > temp2) {
          this.form.endDate = ''
          this.$message.error('End Period must be greater than Start Period')
        }
      }
    },
    CheckedNodes(leafOnly, includeHalfChecked) {
      const indexOfLeaf = this.checkedNodes.indexOf(leafOnly)

      if (indexOfLeaf < 0) {
        this.checkedNodes.push(leafOnly)
      } else {
        this.checkedNodes.splice(indexOfLeaf, 1)
      }
    },
    chartOnLoadComplete() {
      try {
        const chartBase64 = this.$refs.canvas.$refs.canvas.toDataURL()
        this.chartBase64 = chartBase64
      } catch (err) {
        console.log(err)
      }
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    getFirstCharUppercase(text) {
      if (text) {
        return text.charAt(0).toUpperCase() + text.slice(1)
      }
      return ''
    },
    getAllUppercase(text) {
      if (text) {
        return text.toUpperCase()
      }
      return ''
    },
    printToPDF() {
      this.showLoading()

      try {
        let tableHeaders = []
        this.tableColumns.forEach((item) => {
          tableHeaders.push({
            text: item.label,
            alignment: 'center',
            style: 'tableHeader'
          })
        })

        let body = [[...tableHeaders]]

        // Push body with object in table rows
        this.tableRows.forEach((obj) => {
          const entry = Object.entries(obj)
          body.push(
            entry.map((x) => {
              return { text: `${x[1]}`, alignment: 'right', style: 'textSmall' }
            })
          )
        })

        // Format date in body
        body.forEach((item, index) => {
          if (index > 0) {
            // item[0] is datetime
            item[0].text = moment(item[0].text).format(
              this.momentDateOutputFormat
            )
          }
        })

        // Create docDefinition
        const docDefinition = {
          styles: {
            textSmall: {
              fontSize: 10
            },
            tableHeader: {
              bold: true,
              fontSize: 10
            },
            generatedLabel: {
              fontSize: 8,
              color: '#A0AFC0'
            },
            title: {
              bold: true
            }
          },
          content: [
            {
              alignment: 'justify',
              columns: [
                {
                  style: 'generatedLabel',
                  text: `Generated on ${moment().format('DD-MMM-YYYY')}`
                },
                {
                  image: 'logoCorp',
                  width: '70',
                  alignment: 'left'
                }
              ]
            },
            {
              alignment: 'center',
              style: 'title',
              text: `\n AVERAGE ${this.getAllUppercase(
                this.lastPath
              )} REPORT \n`
            },
            {
              alignment: 'center',
              style: 'textSmall',
              text:
                '\n Sensor Type: ' +
                this.sensorTypeOptions.find(
                  (sensorType) => sensorType.value === this.form.sensorType
                )?.label
            },
            {
              alignment: 'center',
              style: 'textSmall',
              text: `Period: ${moment(this.form.startDate).format(
                this.momentDateOutputFormat
              )} to ${moment(this.form.endDate).format(
                this.momentDateOutputFormat
              )}`
            },
            '\n\n',
            {
              image: 'chart',
              width: '500',
              alignment: 'center'
            },
            '\n\n\n',
            {
              table: {
                headerRows: 1,
                widths: [...Array(tableHeaders.length)].map((x) => '*'),
                body: [...body]
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex % 2 === 0 ? '#f5f5f5' : null
                }
              }
            }
          ],
          images: {
            chart: this.chartBase64,
            logoCorp: imagesLib.logoCorp
          }
        }

        pdfMake
          .createPdf(docDefinition)
          .download(
            `${this.getFirstCharUppercase(
              this.lastPath
            )} Average Report ${moment().format('DD/MM/YYYY')}.pdf`
          )
      } catch (err) {
        console.log(err)
        this.hideLoading()
      }
      this.hideLoading()
    },
    async downloadExcelReport() {
      const data = {
        dataForm: this.form.dataForm,
        typeSensor: this.form.sensorType,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        SubDeviceName: [...this.checkedNodes.map((item) => item.label)]
      }

      const fileName = `${this.getFirstCharUppercase(this.lastPath)} Average Report ${moment().format('DD/MM/YYYY')}.xlsx`

      await this.$axios
      .post('ReportPDFetc/DownloadFileReport', data, {
        responseType: 'blob'
      })
      .then((res) => {
        FileSaver.saveAs(res.data, fileName)
      })
      .catch(err => {
        this.$message('Failed to download, please try again.')
        console.log(err)
      })
    },
    downloadReport(command) {
      if (command === 'pdf') this.printToPDF()
      else this.downloadExcelReport()
    }
  }
}
